import React, { useState, useEffect } from 'react';

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.matchMedia('(max-width: 768px)').matches);
  
    useEffect(() => {
      const mediaQuery = window.matchMedia('(max-width: 768px)');
      const handleChange = () => setIsMobile(mediaQuery.matches);
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);
  
    return isMobile;
};

export default useIsMobile;